import { Component, OnInit } from '@angular/core';
import { ClientService } from '../../../services/client.service';
import { ActivatedRoute, Router } from '@angular/router';
import { AlertService } from '../../../services/alert.service';
import { TableColumn } from '../../../models/tables/TableColumn';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { Client } from '../../../models/clients/client';
import { ErrorCollection } from '../../../models/common/errorCollection';
import { TripHistory } from '../../../models/trips/tripHistory';
import { TripHistoryColumns } from '../../../contants/columns/columns.trip.history';

@Component({
	selector: 'app-client-form',
	templateUrl: './client-form.component.html',
	styleUrls: ['./client-form.component.css']
})
export class ClientFormComponent implements OnInit {

	form: FormGroup;
	client: Client = new Client();
	loading: boolean = false;

	tripHistoryColumns: TableColumn[] = TripHistoryColumns;
	tripHistory: TripHistory[] = [];

	constructor(
		private _clientService: ClientService,
		private _activatedRoute: ActivatedRoute,
		private _router: Router,
		private _alertService: AlertService
	) { }

	ngOnInit() {
		this._activatedRoute.params.subscribe(
			val => {
				this.init();
			}
		)
	}

	private init() {
		let id = this._activatedRoute.snapshot.params['id'];
		this.client = new Client();
		this.client.id = id;

		this.form = this.createForm(this.client);

		if (id == 0) {
			this.client.id = 0;
		}
		else {
			this._clientService.getClient(id).subscribe(
				result => {
					if (result == undefined) {
						this.client.id = 0;
					}
					else {
						this.client = result;
						this.form = this.createForm(this.client)
					}
				}
			);
		}
	}

	private createForm(client: Client): FormGroup {
		return new FormGroup({
			name: new FormControl(client.name, [
				Validators.required,
				Validators.maxLength(50)
			]),
			company: new FormControl(client.company, [
				Validators.maxLength(50)
			]),
			dateAccredited: new FormControl(client.dateAccredited, [
				Validators.required
			])
		});
	}

	onFormSubmit(formValue) {
		if(!this.form.valid){
			this._alertService.showError('Invalid form data.');
			return;
		}

		this.client.name = formValue.name;
		this.client.dateAccredited = formValue.dateAccredited;
		this.client.company = formValue.company;
		
		this.loading = true;
		if (this.client.id == undefined || this.client.id == 0) {
			this.createClient();
		}
		else {
			this.updateClient();
		}
	}

	private createClient() {
		this._clientService.addClient(this.client).subscribe(
			result => {
				if (result != undefined && result['object'] != undefined) {
					this.client = result.object;
					this._alertService.showSuccess('Client information has been registered.');
				}
				else {
					this._alertService.displayErrorResult(result.errorCollection);
				}
				this.loading = false;
			}
		);
	}

	private updateClient() {
		this._clientService.updateClient(this.client).subscribe(
			result => {
				if (result != undefined && result['object'] != undefined) {
					this.client = result.object;
					this._alertService.showSuccess('Client information has been updated.');
				}
				else {
					this._alertService.displayErrorResult(result.errorCollection);
				}
				this.loading = false;
			}
		);
	}

	isControlInvalid(controlName: string) {
		let control = this.form.controls[controlName];
		return control.invalid && (control.dirty || control.touched);
	}
}



// WEBPACK FOOTER //
// ./src/app/components/clients/client-form/client-form.component.ts